import { Radio, TextField } from "@mui/material";
import { styled } from "@mui/system";
import {
  AUTH_URI,
  CLIENT_ID,
  LOGOUT_REDIRECT_URI,
  LOGOUT_URI,
  REDIRECT_URI,
  TOKEN_URI,
} from "../constants/constant";

export const blackbaudConfig = {
  clientId: CLIENT_ID,
  authorizationEndpoint: AUTH_URI,
  tokenEndpoint: TOKEN_URI,
  redirectUri: REDIRECT_URI,
  scope: "someScope openid",
  // logoutEndpoint: LOGOUT_URI,
  // logoutRedirect: LOGOUT_REDIRECT_URI,
  response_type: "code",
  onRefreshTokenExpire: () => {
    if (window.confirm("Session expired. Please log in again to continue.")) {
      //window.location.reload();
      localStorage.clear();
      window.location.href = "/login";
    }
  },
  decodeToken: true,
  state: "fdf80155",
  clearURL: false,
  autoLogin: false,
  storage: "local",
};

export const validateEmail = (email) => {
  const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  return regex.test(email);
};

export const validateName = (name) => {
  const regex = /^[a-zA-Z.'-]*$/i;
  return regex.test(name);
};

export const validateId = (name) => {
  const regex = /<\s*script.*?>|<\/\s*script\s*>|<|>/gi;
  return !regex.test(name);
};

export const isPbixFile = (fileName) => {
  const allowedExtensions = ["pbix"];
  const fileExtension = fileName.slice(
    ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
  );

  return allowedExtensions.includes(fileExtension.toLowerCase());
};

export const truncateText = (text, limit) => {
  if (text.length <= limit) {
    return text;
  }
  return text.slice(0, limit) + "...";
};

export const validateDbServer = (value) => {
  if (!value) return false;

  const azureSqlServerRegex = /^[a-zA-Z0-9-]+\.database\.windows\.net$/;

  return azureSqlServerRegex.test(value.trim());
};

export const validateDbName = (value) => {
  if (!value) return false;

  const dbNameRegex = /^[a-zA-Z0-9_-]{1,128}$/;
  return dbNameRegex.test(value.trim());
};

export const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-input": {
    height: "16px",
    fontSize: "16px",
    fontWeight: 500,
    color: "#5a5a5a",
    fontFamily: "Montserrat",
    letterSpacing: "-0.02em",
  },
  "& .MuiInputBase-input::placeholder": {
    fontSize: "16px",
    fontWeight: 500,
    color: "#8a8a8a",
    fontFamily: "Montserrat",
    letterSpacing: "-0.02em",
  },
  "& .MuiInputBase-root-MuiOutlinedInput-root": {
    fontSize: "16px",
    fontWeight: 500,
    color: "#8a8a8a",
    fontFamily: "Montserrat",
    letterSpacing: "-0.02em",
  },
}));

export const CustomRadio = styled(Radio)(({ theme }) => ({
  "&.Mui-checked": {
    color: "#56a5a1",
  },
}));

export const savePdf = (data, reportTitle) => {
  if (data) {
    try {
      const blob = new Blob([data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // a.download = "document.pdf";
      a.download = `${reportTitle ? reportTitle : "document"}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error saving PDF:", error);
    }
  }
};

export const removeSlashes = (inputString) => {
  return inputString.replace(/\//g, " ");
};

export const removeSlashesWithoutSpace = (inputString) => {
  return inputString.replace(/\//g, "");
};

export const keysHaveValue = (obj, keysToCheck) =>
  keysToCheck.every(
    (key) =>
      obj[key] !== 0 &&
      obj[key] !== "" &&
      obj[key]?.outputId !== "" &&
      obj[key] !== undefined
  );

export const isValidFileType = (file) => {
  const validImageTypes = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/gif",
    "image/bmp",
    "image/webp",
    "image/tiff",
    "image/svg+xml",
  ];
  const validVideoTypes = [
    "video/mp4",
    "video/mpeg",
    "video/ogg",
    "video/webm",
    "video/avi",
    "video/mov",
    "video/wmv",
    "video/3gpp",
    "video/3gpp2",
  ];
  return (
    validImageTypes?.includes(file?.type) ||
    validVideoTypes?.includes(file?.type)
  );
};

export function generateFinancialYears(currentYear) {
  return [
    {
      name: `Jan ${currentYear} - Dec ${currentYear}`,
      value: "January",
    },
    {
      name: `Jul ${currentYear} - Jun ${currentYear + 1}`,
      value: "July",
    },
  ];
}

export function generateFinancialYearMonths() {
  var monthList = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return monthList.map((e) => {
    return { name: e, value: e };
  });
}

export const reportsOrderList = [
  {
    key: "Alumni",
    value: [
      "Alumni Overview",
      "Alumni Education",
      "Alumni Giving",
      "Alumni Employment",
      "Alumni Profile",
      "Alumni Engagement",
    ],
  },
  {
    key: "Fundraising Performance Overview",
    value: [
      "Overall Performance Trends",
      "Monthly Trends",
      "Funds, Campaigns and Appeals",
      "Variance Analysis",
      "Channel Performance",
      "Program Performance to Target",
      "Program Performance – Return on Investment",
      "Pareto Principle",
    ],
  },
  {
    key: "Supporter Trends",
    value: [
      "Donor Loyalty",
      "Acquisition",
      "Second Gift Rate",
      "Retention",
      "Attrition",
      "Reactivation",
    ],
  },
  {
    key: "Donor Insights",
    value: [
      "Donor and Revenue Coverage",
      "Donor Profile",
      "Contactability Profile",
      "Lifetime Value",
    ],
  },
  {
    key: "Single Giving and Appeals",
    value: [
      "Single Giving Overview",
      "Appeal Performance",
      "Appeal Performance RFM",
    ],
  },
  {
    key: "Gifts in Wills",
    value: [
      "Prospective Gifts in Wills Overview",
      "Prospective Gifts in Wills Analysis",
      "Realised Gifts in Wills Overview",
      "Realised Gifts in Wills Analysis",
    ],
  },
  {
    key: "Major Giving",
    value: [
      "Portfolio Overview",
      "Portfolio Performance",
      "Top Donors",
      "LYBUNT",
      "Giving Level Analysis – Single Giving",
      "Giving Level Analysis – Annual Giving",
    ],
  },
];

export function getFinancialYearOptions(startMonthName) {
  if (!startMonthName) return [];

  const currentYear = new Date().getFullYear();
  const options = [];

  const isJanuaryStart = startMonthName === "January";

  for (let i = 0; i < 4; i++) {
    const year = currentYear - i;
    const shortYear = year.toString().slice(2);

    if (isJanuaryStart) {
      // FY2025, FY2024, FY2023
      options.push({
        label: `${year}`,
        value: `${year}`,
        isFinancialYear: false, // calendar-aligned FY
      });
    } else {
      // FY25-26, FY24-25
      options.push({
        label: `FY ${shortYear}-${(year + 1).toString().slice(2)}`,
        value: `${year}`,
        isFinancialYear: true,
      });
    }
  }

  return options;
}
